import React, { useEffect, useRef, useState } from 'react';
import '../../Static/Master/PackPrintStruct.css';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { fetchAdminSaleData, fetchUserSaleData, updateAdminSaleEntry, updateUserSaleEdit } from '../../Store/PHPSlice/stockApi';
import { selectAdminSaleData, selectUserSaledata } from '../Selectors/Master/OutwardSelectors';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { selectFirm } from '../Selectors/Master/ItemSelectors';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import Dropdown from '../FieldsComponents/Dropdown';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import styled, { cutDates, inputStyles, stockNumber, inputNumbersmall, inputStyle11 } from '../../Utils/inputChanges';
import axios from 'axios';



const UserSaleEdit = () => {
    const { Id } = useParams();
    const dispatch = useDispatch();
    const userdata = JSON.parse(sessionStorage.getItem('user'));

    const baseUrl = process.env.REACT_APP_BASE_URL;
    const componentRef = useRef();
    const [selectedIds, setSelectedIds] = useState([]);
    const [deletedItems, setDeletedItems] = useState([]);
    const [formData, setFormData] = useState({
        ID: '',
        adsaleId: parseInt(Id),
        balamt: '',
        billNo: '',
        cgst: '',
        discnt_amt: '',
        discnt_type: '',
        discnt_val: '',
        dt: '',
        freight_ch: '',
        gst: '',
        gst_val: '',
        igst: '',
        pigst: '',
        netamt: '',
        other_ch: '',
        schlId: '',
        schlNm: '',
        schlcd: '',
        sgst: '',
        totamt: '',
        totqty: '',
        zoneId: '',
        zoneNm: '',
        firmId: '',
        firmNm: '',
        adrs: '',
        schladrs: "",
        firmph: '',
        fgst: '',
        schlph: '',
        totrate: '',
        sgstper: '',
        cgstper: '',
        igstper: '',
        schlcd: '',
        bankNm: '',
        ifsc: '',
        ac_no: '',
        branchNm: '',
        studNm: '',
        studId: '',
        std: '',
        div: '',
        userId: userdata?.ID,
        studph: '',
        paymode: '',
        bnkNm: '',
        transId: '',
        payamt: '',
        item: '',
        size: ''
    });
    const [packInfo, setPackInfo] = useState([]);
    const [selectFirmdata, setSelectFirmdata] = useState({});
    const [packData, setPackData] = useState([]);

    const [adsaleData, setAdsaleData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [itemlist, setItemlist] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [newData, setNewData] = useState({
        totqty: '0',
        netamt: '0',
        totamt: '0'
    });

    // const packData = useSelector(selectUserSaledata);
    const firmlist = useSelector(selectFirm);
    const isDesktop = useMediaQuery('(min-width:768px)');
    // console.log(packData)
    useEffect(() => {
        const data = {
            usId: Id
        };
        dispatch(fetchCompanyData());
        fetchSchlItemslist();
        dispatch(fetchUserSaleData(data))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                setPackData(result);

            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });
    }, [Id, dispatch]);

    // const dropdownlistDepartment = [
    //     {
    //         label: 'Item',
    //         id: 'item',
    //         options: [],
    //         value: formData.item,
    //         onChange: (newValue) => { },
    //         getOptionLabel: (option) => option.itemNm || '',
    //         isOptionEqualToValue: (option, value) => option.ID === value.ID,
    //         valueFinder: (options, value) => {
    //             if (Array.isArray(options)) {
    //                 return options.find(item => item.ID === value) || null;
    //             }
    //             return null;
    //         }

    //     }
    // ];

    useEffect(() => {

        if (packData?.data) {
            const item = packData?.data[0];
            const {
                ID,
                balamt,
                memo,
                cgst,
                discnt_amt,
                discnt_type,
                discnt_val,
                dt,
                DT,
                freight_ch,
                gst,
                gst_val,
                igst,
                netamt,
                other_ch,
                schlId,
                schlNm,
                sgst,
                totamt,
                totqty,
                zoneId,
                zoneNm,
                firmId,
                firmNm,
                fadrs,
                schladrs,
                firmgst,
                firmph,
                schlph,
                schlcd,
                bankNm,
                ifsc,
                ac_no,
                branchNm,
                studId,
                studNm,
                div,
                std,
                ph,
                paidamt,
                paymode,
                payableamt,
                chqno
            } = item;
            const firmdata = firmlist?.data?.find(item => item.ID === firmId);
            setSelectFirmdata(firmdata);
            const info = packData.info;
            const totrate = info?.reduce((acc, sum) => acc + parseFloat(sum.srate), 0);
            let sgstper, igstper, cgstper;
            if (igst !== '0') {
                igstper = gst;
                sgstper = 0;
                cgstper = 0;

            } else {
                sgstper = (parseFloat(gst_val) / 2);
                cgstper = (parseFloat(gst_val) / 2);
                igstper = 0;
            }
            setFormData(prev => ({
                ...prev,
                ID: ID,
                balamt: balamt,
                billNo: memo,
                cgst: cgst,
                discnt_amt: discnt_amt,
                discnt_type: discnt_type,
                discnt_val: discnt_val,
                dt: DT,
                freight_ch: freight_ch,
                fgst: firmgst,
                gst: gst,
                gst_val: gst_val,
                igst: igst,
                netamt: netamt,
                other_ch: other_ch,
                schlId: schlId,
                schlNm: schlNm,
                sgst: sgst,
                totamt: totamt,
                totqty: totqty,
                zoneId: zoneId,
                zoneNm: zoneNm,
                firmId: firmId,
                firmNm: firmNm,
                adrs: fadrs,
                schladrs: schladrs,
                schlph: schlph,
                firmph: firmph,
                totrate: totrate,
                igstper: igstper,
                sgstper: sgstper,
                cgstper: cgstper,
                schlcd: schlcd,
                bankNm: bankNm,
                ac_no: ac_no,
                ifsc: ifsc,
                branchNm: branchNm,
                studId: studId,
                studNm: studNm,
                div: div,
                std: std,
                schlcd: schlcd,
                pigst: igst,
                studph: ph,
                payamt: paidamt,
                transId: chqno,
                paymode: paymode
            }));

            setNewData(prev => ({
                ...prev,
                totamt: totamt,
                totqty: totqty,
                netamt: netamt
            }));
        }
        if (packData?.info && packData.info?.length > 0) {
            const info = packData.info;
            const clonedInfo = packData.info.map(item => ({ ...item }));
            const totrate = clonedInfo?.reduce((acc, sum) => acc + parseFloat(sum.srate), 0);

            setPackInfo(clonedInfo);
            // console.log(packData);
        }
    }, [packData]);

    const handleCheckboxChange = (checked, id) => {
        if (checked) {
            setSelectedIds((prev) => [...prev, id]);
            // console.log(selectedIds);
        } else {
            setSelectedIds((prev) => prev.filter((itemId) => itemId !== id));
            // console.log(selectedIds);
        }
        // console.log(selectedIds);
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            // Select all item.IDs
            const allIds = packInfo.map((item) => item.ID);
            setSelectedIds(allIds);
        } else {
            // Deselect all
            setSelectedIds([]);
        }
    };

    const handleInputChange = (index, field, value) => {
        const newValue = field === 'bqty' || field === 'disrate' ? Number(value) : value;

        if (field === 'bqty') {
            const gqty = packInfo[index]?.gqty ?? 0;
            if (newValue > gqty) {
                alert(`Aavialable stock quantity is : ${gqty}`);
                return; // Stop the update
            }
        }

        const updated = [...packInfo];

        updated[index] = {
            ...updated[index],
            [field]: newValue
        };

        // Recalculate amount only if bqty or srate changed
        if (field === 'bqty' || field === 'disrate') {
            const bqty = updated[index].bqty ?? 0;
            const srate = updated[index].disrate ?? 0;
            updated[index].disamt = parseFloat(bqty * srate);
        }

        const totqty = updated?.reduce((acc, sum) => acc + parseFloat(sum.bqty), 0);
        const totamt = updated?.reduce((acc, sum) => acc + parseFloat(sum.disamt), 0);
        const disamt = Math.round((parseFloat(formData.discnt_val) / 100) * parseFloat(totamt));
        const grandTot = totamt;
        let gstval = Math.round(grandTot * (parseFloat(formData.gst_val) / 100));
        const netamt = totamt + parseFloat(gstval) + parseFloat(formData.other_ch) + parseFloat(formData.freight_ch);
        let igst = 0, cgst = 0, sgst = 0;
        if (formData.gst === '1') {

            // console.log(formData.igst);

            if (formData.pigst === '0') {
                const halfgst = Math.round(gstval / 2).toFixed(2);
                sgst = halfgst;
                cgst = halfgst;
            } else {
                igst = gstval;
            }
        }
        setPackInfo(updated);
        setFormData(prev => ({
            ...prev,
            totqty: totqty,
            totamt: totamt,
            netamt: netamt,
            // discnt_amt: disamt,
            igst: igst,
            cgst: cgst,
            sgst: sgst,
        }));
    };

    const handleInputChange2 = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        switch (dropdownType) {
            case 'size':
                if (value) {
                    let selectObj = adsaleData?.find((val) => val.ID === value);
                    // console.log(selectObj)
                    if (selectObj) {
                        const isAlreadyAdded = tableData.some(item => item.ID === selectObj.ID);

                        if (!isAlreadyAdded) {

                            setTableData(prev => [...prev, selectObj]);

                            setFormData({
                                ...formData,
                                size: ''
                            });
                        } else {
                            alert("This item is already Exists.");
                            setFormData({
                                ...formData,
                                size: ''
                            });
                        }
                    }
                };
                break;
            case 'item':
                if (value) {
                    const selectObj = itemlist?.find(itm => itm.ID === value);
                    // console.log(items)
                    const stkId = selectObj?.stkId;
                    // console.log(selectObj)
                    const data = {
                        itemId: value,
                        stkId: selectObj?.id
                    };
                    // console.log(data)

                    fetchSchlStkData(data);
                } else {
                    setAdsaleData([]);
                }
                break;

            default:
                break;
        };
    };

    const handleDelete = () => {
        if (selectedIds.length === 0) return;

        // Filter items to delete and to keep
        const toDelete = packInfo.filter(item => selectedIds.includes(item.ID));
        const toKeep = packInfo.filter(item => !selectedIds.includes(item.ID));

        const totqty = toKeep?.reduce((acc, sum) => acc + parseFloat(sum.bqty), 0);
        const totamt = toKeep?.reduce((acc, sum) => acc + parseFloat(sum.disamt), 0);
        const disamt = Math.round((parseFloat(formData.discnt_val) / 100) * parseFloat(totamt));
        const grandTot = totamt;
        let gstval = Math.round(grandTot * (parseFloat(formData.gst_val) / 100));
        const netamt = totamt + gstval + parseFloat(formData.other_ch) + parseFloat(formData.freight_ch);
        let igst = 0, cgst = 0, sgst = 0;
        if (formData.gst === '1') {

            if (formData.pigst !== '0') {
                igst = gstval;
            } else {
                const halfgst = Math.round(gstval / 2).toFixed(2);
                sgst = halfgst;
                cgst = halfgst;
            }
        }
        // Update states
        setDeletedItems(prev => [...prev, ...toDelete]);
        setPackInfo(toKeep);
        setSelectedIds([]);
        setFormData(prev => ({
            ...prev,
            totqty: totqty,
            totamt: totamt,
            netamt: netamt,
            // discnt_amt: disamt,
            igst: igst,
            cgst: cgst,
            sgst: sgst,
        }));

        // console.log("Deleted items:", toDelete);
    };

    function numberToWords(num) {
        const below20 = [
            'Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
            'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
            'Eighteen', 'Nineteen'
        ];
        const tens = [
            '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
        ];
        const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

        if (num === 0) return below20[0];

        let words = '';

        let i = 0;
        while (num > 0) {
            if (num % 1000 !== 0) {
                words = helper(num % 1000) + (thousands[i] ? ' ' + thousands[i] : '') + ' ' + words;
            }
            num = Math.floor(num / 1000);
            i++;
        }

        return words.trim().toUpperCase();

        function helper(n) {
            if (n === 0) return '';
            if (n < 20) return below20[n];
            if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + below20[n % 10] : '');
            return below20[Math.floor(n / 100)] + ' Hundred' + (n % 100 !== 0 ? ' ' + helper(n % 100) : '');
        }
    };

    const fields12 = {
        'Cheque': {
            label: 'Bank Name',
            name: 'bnkNm'
        }
    };
    const fields13 = fields12[formData.paymode];

    const fields14 = [
        { label: 'Pay Amount', name: 'payamt' },
    ];
    const paymodelist = [
        { label: 'Cash', value: 'Cash' },
        { label: 'Cheque', value: 'Cheque' },
        { label: 'NEFT', value: 'NEFT' },
        { label: 'IMPS', value: 'IMPS' },
        { label: 'Phone Pay', value: 'Phone-Pay' },
        { label: 'G-Pay', value: 'GPay' },
        { label: 'Paytm', value: 'Paytm' },
        { label: 'Bhim-UPI', value: 'Bhim-UPI' }
    ];

    const fields10 = {
        'Cheque': {
            label: 'Transaction ID.',
            name: 'transId'
        },
        'NEFT': {
            label: 'Transaction ID.',
            name: 'transId'
        },
        'IMPS': {
            label: 'Transaction ID.',
            name: 'transId'
        },
        'RTGS': {
            label: 'Transaction ID.',
            name: 'transId'
        },
        'Phone-Pay': {
            label: 'Transaction ID.',
            name: 'transId'
        },
        'GPay': {
            label: 'Transaction ID.',
            name: 'transId'
        },
        'Paytm': {
            label: 'Transaction ID.',
            name: 'transId'
        },
        'Bhim-UPI': {
            label: 'Transaction ID.',
            name: 'transId'
        }
    };

    const fields11 = fields10[formData.paymode];


    const dropdownlistfirst = [
        {
            label: 'Payment Mode',
            id: 'paymode',
            options: paymodelist || [],
            value: formData.paymode,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'paymode', value: newValue ? newValue.value : '' } }, 'paymode'),
            getOptionLabel: (option) => option.label || '',
            isOptionEqualToValue: (option, value) => option.value === value.value,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.value === value) || null;
                }
                return null;
            },
        }
    ];


    // Example usage:
    // console.log(numberToWords(123)); // Output: "One Hundred Twenty Three"
    // console.log(numberToWords(1234567)); // Output: "One Million Two Hundred Thirty Four Thousand Five Hundred Sixty Seven"
    // console.log(packInfo);

    // console.log(selectFirmdata);
    function postObj(packInfo, deletedItems, formData, newData, tableData) {
        const data = {
            updatedData: packInfo,
            deletedData: deletedItems,
            totqty: newData.totqty,
            totamt: newData.totamt,
            // discnt_amt: formData.discnt_amt,
            igst: formData.igst,
            cgst: formData.cgst,
            sgst: formData.sgst,
            userId: formData.userId,
            adsaleId: formData.adsaleId,
            netamt: newData.netamt,
            chqno: formData.chqno,
            payamt: formData.payamt,
            paymode: formData.paymode,
            bnkNm: formData.bnkNm,
            tableData: tableData
        };
        return data;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // if (formData.billNo === '') {
        //     alert('Please Enter Bill No.');
        //     return; // Stop form submission
        // }

        // if (formData.firm === '') {
        //     alert('Please Select Firm.');
        //     return; // Stop form submission
        // }
        const postobj = postObj(packInfo, deletedItems, formData, newData, tableData);
        // console.log(postobj);

        dispatch(updateUserSaleEdit(postobj))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("User Sale Updated");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    const dropdownOrdType = [
        {
            label: 'Item',
            id: 'item',
            options: itemlist || [],
            value: formData.item,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'item', value: newValue ? newValue.ID : '' } }, 'item'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        },
        {
            label: 'Size',
            id: 'size',
            options: adsaleData || [],
            value: formData.size,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'size', value: newValue ? newValue.ID : '' } }, 'size'),
            getOptionLabel: (option) => option.size || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        }

    ];

    const fetchSchlStkData = async (id) => {
        const { stkId, itemId } = id;
        try {
            const response = await axios.get(`${baseUrl}?apicall=getAdminStkItemwise&stkId=${stkId}&itemId=${itemId}`);
            setAdsaleData(response?.data?.info);

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchSchlItemslist = async () => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getSchoolStockItemslist`);
            setItemlist(response?.data?.data);

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const handleChange = (index, field, value) => {
        const updatedData = [...tableData];

        if (field === 'issqty') {
            const enteredQty = parseFloat(value || 0);
            const availableQty = parseFloat(updatedData[index].bqty || 0);
            const prevSrate = parseFloat(updatedData[index][field] || 0);
            const disrate = parseFloat(updatedData[index].disrate || 0);
            if (enteredQty > availableQty) {
                alert("Issued quantity cannot be greater than available quantity (bqty).");
                return; // Don't update the state
            }
            const total = enteredQty * disrate;
            updatedData[index][field] = enteredQty;
            const diff = availableQty - enteredQty;
            updatedData[index].bal_qty = Math.round(diff);
            updatedData[index].total = Math.round(total);
            setTableData(updatedData);
            const totissqty = updatedData?.reduce((acc, sum) => acc + parseFloat(sum.issqty), 0) + parseFloat(formData.totqty);

            const totamt = updatedData?.reduce((acc, sum) => acc + parseFloat(sum.total), 0) + parseFloat(formData.totamt);
            const netamt = totamt || 0 + parseFloat(formData.netamt);
            // Update the total quantity
            setNewData(prev => ({
                ...prev,
                totqty: totissqty,
                totamt: totamt,
                netamt: netamt
            }));
        };
    };

    const handleCheckboxChange2 = (index) => {
        setSelectedRows((prevSelected) =>
            prevSelected.includes(index)
                ? prevSelected.filter((i) => i !== index)
                : [...prevSelected, index]
        );
    };

    const handleDeleteSelected = () => {
        const newData = tableData?.filter((_, index) => !selectedRows.includes(index));
        const totqty = newData?.reduce((acc, sum) => acc + parseFloat(sum.issqty), 0) + parseFloat(formData.totqty);
        const totamt = newData?.reduce((acc, sum) => acc + parseFloat(sum.total), 0) + parseFloat(formData.totamt);
        const netamt = totamt;
        // Update the total quantity
        setNewData(prev => ({
            ...prev,
            totamt: totamt,
            netamt: netamt,
            totqty: totqty
        }));
        setTableData(newData); // Make sure you have setTableData state function
        setSelectedRows([]);   // Clear selection
    };

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    return (

        <Grid item xs={12}>
            <Paper>
                <div ref={componentRef} style={{ padding: '1%', marginBottom: '20px' }}>
                    {/* Heading */}
                    <h3 className="heading">Estimate Bill</h3>

                    {/* Upper part: Two tables side by side */}
                    <div className="flex-container">
                        {/* Left Table */}
                        <table>
                            <tbody>
                                <tr>
                                    <td><h2>{formData.firmNm}</h2>
                                        <b>Add.:</b>{formData.adrs}
                                        <br />
                                        <b>Contact:</b>{formData.firmph} <br />
                                        <b>GST No.:</b> {formData.fgst}
                                    </td>
                                </tr>
                                <tr>
                                    <td><h3>TO:</h3>
                                        <b>Student Name:</b><b style={{ color: 'blue' }}>{formData.studNm} </b> <br />
                                        <b>Std:</b> <span style={{ color: 'blue' }}>{formData.std}</span><br />
                                        <b>Div:</b> <span style={{ color: 'blue' }}>{formData.div}</span><br />
                                        <b>Contact:</b> <span style={{ color: 'blue' }}>{formData.studph}</span><br />
                                        <b>School Code:</b><b style={{ color: 'blue' }}>{formData.schlcd} </b> <br />
                                    </td>
                                </tr>

                            </tbody>
                        </table>

                        {/* Right Table */}
                        <table>

                            <tbody>

                                <tr>
                                    <td>Bill No:</td>
                                    <td><b>{formData.billNo}</b></td>
                                </tr>
                                <tr>
                                    <td>Date:</td>
                                    <td>{formData.dt}</td>
                                </tr>
                                <tr>
                                    <td>Transport:</td>
                                    <td>{formData.trspt}</td>
                                </tr>
                                <tr>
                                    <td>Remark:</td>
                                    <td>{formData.remark}</td>
                                </tr>
                                <tr>
                                    <td>No. of Cartoons:</td>
                                    <td>{formData.parcelqty}</td>
                                </tr>
                                <tr>
                                    <td>Ship To:</td>
                                    <td>{formData.shtoNm}</td>
                                </tr>
                                <tr>
                                    <td>Ship Address:</td>
                                    <td>{formData.shtoadrs}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <Grid container alignItems="center" justifyContent="space-between" spacing={2}>

                        <Grid item xs={12} sm={2} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <div style={{ textAlign: 'right', margin: '10px 0' }}>
                                <Button variant="contained" color="primary" onClick={handleDelete}>
                                    Delete
                                </Button>
                            </div>
                        </Grid>
                    </Grid>

                    {/* Main Table */}
                    {packInfo.length > 0 &&

                        <table className="main-table">
                            <thead>
                                <tr>
                                    <th>
                                        <input
                                            type="checkbox"
                                            checked={packInfo.length > 0 && selectedIds.length === packInfo.length}
                                            onChange={handleSelectAll}
                                        />
                                    </th>
                                    <th>SR NO.</th>
                                    <th>PARTICULARS</th>
                                    <th>SIZE</th>
                                    <th>QTY</th>
                                    <th>RATE</th>
                                    <th>AMOUNT</th>
                                </tr>
                            </thead>
                            <tbody>
                                {packInfo.map((item, index) => (
                                    <tr key={index}>
                                        <td><input
                                            type='checkbox'
                                            checked={selectedIds.includes(item.ID)}
                                            onChange={(e) => handleCheckboxChange(e.target.checked, item.ID)}
                                        ></input></td>
                                        <td>{index + 1}</td>
                                        <td>{item.itemNm}</td>
                                        <td>{item.size}</td>
                                        <td>
                                            <input
                                                type="text"
                                                value={item.bqty}
                                                onChange={(e) => handleInputChange(index, 'bqty', e.target.value)}
                                                style={{ width: '60px' }}
                                            />
                                        </td>
                                        {/* <td>
                                            <input
                                                type="text"
                                                value={item.disrate}
                                                onChange={(e) => handleInputChange(index, 'disrate', e.target.value)}
                                                style={{ width: '60px' }}
                                            />
                                        </td> */}
                                        <td>{item.disrate}</td>
                                        <td>{item.disamt}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><b>Total</b></td>
                                    <td><b>{formData.totqty}</b></td>
                                    <td><b></b></td>
                                    <td><b>{formData.totamt}</b></td>
                                </tr>
                            </tbody>
                        </table>
                    }




                    <Grid item xs={12} sm={10} margin={2}>

                        <Grid container spacing={2} >
                            {
                                dropdownOrdType && dropdownOrdType?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        handleAddNew={drop.handleAddNew}
                                        btnlabel={drop.btnlabel}
                                        handleDropdownOpen={drop.handleDropdownOpen}
                                        handleDropdownClose={drop.handleDropdownClose}
                                        sm={drop.sm}
                                    />
                                ))
                            }


                            {fields14?.map((field) => (
                                <DateInputComponent
                                    key={field.name}
                                    formData={formData}
                                    handleDateChange={handleInputChange2}
                                    handleInputChange={handleInputChange2}
                                    styled={styled}
                                    inputStyles={inputStyles}
                                    isDesktop={isDesktop}
                                    field={field}
                                />
                            ))}
                            {
                                dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                    <Dropdown
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                    />
                                ))
                            }



                            {
                                fields11 &&
                                <DateInputComponent
                                    formData={formData}
                                    handleDateChange={handleInputChange2}
                                    handleInputChange={handleInputChange2}
                                    styled={styled}
                                    inputStyles={inputStyles}
                                    isDesktop={isDesktop}
                                    field={fields11}
                                />
                            }



                            {
                                fields13 &&
                                <DateInputComponent
                                    formData={formData}
                                    handleDateChange={handleInputChange2}
                                    handleInputChange={handleInputChange2}
                                    styled={styled}
                                    inputStyles={inputStyles}
                                    isDesktop={isDesktop}
                                    field={fields13}
                                />
                            }

                            <Button
                                variant="contained"
                                color="error"
                                onClick={handleDeleteSelected}
                                disabled={selectedRows.length === 0}
                                style={{ marginTop: '16px' }}
                            >
                                Delete
                            </Button>

                            {Array.isArray(tableData) && tableData.length > 0 &&
                                <>
                                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow className='tbl-row'>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Select</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Item</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Rate</TableCell>
                                                    {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Discount(%)</TableCell> */}
                                                    {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Rate</TableCell> */}
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Stock Qty</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Qty</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Bal Qty</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {tableData.length > 0
                                                    ? tableData?.map((form, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedRows.includes(index)}
                                                                    onChange={() => handleCheckboxChange2(index)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.itemNm}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.size}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.disrate}</TableCell>
                                                            {/* <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.discnt_val}</TableCell> */}
                                                            {/* <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.disrate}</TableCell> */}
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.bqty}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                <input type="text"
                                                                    value={form.issqty || ''}
                                                                    name='issqty'
                                                                    onChange={(e) => handleChange(index, 'issqty', e.target.value)}
                                                                    style={{ height: '25px', width: '60px' }}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.bal_qty}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.total}</TableCell>
                                                        </TableRow>
                                                    ))
                                                    : ''}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </>
                            }
                        </Grid>
                    </Grid>

                    {/* Footer */}
                    <div className="flex-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>AMOUNT IN WORDS:
                                        <b>{numberToWords(parseFloat(newData.netamt))}</b>
                                    </td>


                                </tr>
                                <tr>
                                    <td>TOTAL QTY: <b> {newData.totqty}</b></td>
                                </tr>

                            </tbody>
                        </table>
                        <table>

                            <tbody>

                                <tr>
                                    <td><b>SUB TOTAL :</b></td>
                                    <td><b>{newData.totamt}</b></td>
                                </tr>

                                <tr>

                                    <td><b style={{ color: 'blue' }}>GRAND TOTAL</b></td>
                                    <td>
                                        <b style={{ color: 'blue' }}>{newData.netamt}</b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <Grid item xs={12} textAlign="center">
                        <Button variant="contained" color="primary" style={{ margin: '10px 0' }} onClick={handleSubmit}>Update</Button>
                    </Grid>
                </div>




                {/* <div style={{ margin: '2% 5%' }}>
                    <ReactToPrint
                        trigger={() => <Button variant="contained" color="primary">Print</Button>}
                        content={() => componentRef.current}
                    />
                </div> */}
            </Paper>
        </Grid>
    );
};

export default UserSaleEdit;
